import React from "react";
import styles from "./Spinner.module.css"

function Spinner(props){


    let className = styles.spinner.concat(" progress-spinner progress-spinner-active")

    return (
        <div className={styles.spinnerContainer} style={{display: props.show?null:"none"}}>
            <div className={className} role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
    )

}

export default Spinner